import {createSlice} from '@reduxjs/toolkit';
import {getCookie} from '../../helpers/cookies';
import {CookieNames} from '../../generalTypes';
import {State} from './types';

const initialState: State = {
    isAuthorized: !!getCookie(CookieNames.refreshToken),
    accessToken: getCookie(CookieNames.accessToken) || null,
    refreshToken: getCookie(CookieNames.refreshToken) || null,
    user: null
};

const slice = createSlice({
    name: 'authorization',
    initialState,
    reducers: {
        setAccessToken(state, action) {
            state.accessToken = action.payload;
        },
        setRefreshToken(state, action) {
            state.refreshToken = action.payload;
            state.isAuthorized = !!action.payload;
        },
        setUser(state, action) {
            state.user = action.payload;
        },
        unauthorize(state) {
            state.user = null;
            state.isAuthorized = false;
            state.accessToken = null;
            state.refreshToken = null;
        }
    },
    selectors: {
        getIsAuthorized: state => state.isAuthorized,
        getAccessToken: state => state.accessToken,
        getRefreshToken: state => state.refreshToken,
        getUser: state => state.user
    }
});

export const {
    setAccessToken,
    setRefreshToken,
    setUser,
    unauthorize
} = slice.actions;
export const {
    getIsAuthorized,
    getAccessToken,
    getRefreshToken,
    getUser
} = slice.selectors;
export default slice.reducer;
